import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { AlertController, LoadingController } from 'ionic-angular';
import { ComplaintsProvider } from '../../providers/complaints/complaints';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import { ComplaintTabsPage } from '../complaint-tabs/complaint-tabs';
import { ToastProvider } from '../../providers/toast/toast';
import { LoginProvider } from '../../providers/login/login';
import { ExtraProvider } from '../../providers/extra/extra';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import moment from 'moment';

import { jsonpCallbackContext } from '@angular/common/http/src/module';

declare let window: any; 

@IonicPage()
@Component({
  selector: 'page-add-complaints-form',
  templateUrl: 'add-complaints-form.html'
})

export class AddComplaintsFormPage {

  vFromDate: Date;
  vToDate: Date;
  // validateComplaintVisitTime = false;
  myDate: any;
  societyId: number;
  description: string;
  loader = this.loadingCtrl.create({});

  data: any;
  events: any;
  visit = "asap";
  remark =true;
  commonAreas = [];
  uploaded: boolean = false;
  disableDesc = true;
  customAreas: any;
  associatedUnits=[];
  compressing = false;
  isAndroid = true;
  today : any;
  societyConfig = {
    complaint_lock_time: {from:moment().format('hh:mm'),to:moment().format('hh:mm')}
  }
  complaint_lock_time_from_array=[];
  complaint_lock_time_to_array=[];
  permissions = false;
  flat_no:any;

  // options: CameraOptions = {
  //   quality: 50,
  //   destinationType: this.camera.DestinationType.DATA_URL,
  //   encodingType: this.camera.EncodingType.JPEG,
  //   mediaType: this.camera.MediaType.PICTURE,
  //   // correctOrientation: true,
  //   // saveToPhotoAlbum: false,
  // }

  item: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
  // private camera: Camera, 
  public alertCtrl: AlertController, 
  private complaintsProvider:ComplaintsProvider, 
  // private imageResizer: ImageResizer,
  private translate: TranslateService,
  private extra: ExtraProvider,
  private toast: ToastProvider,
  private loadingCtrl: LoadingController,
  private ref: ChangeDetectorRef,
  private platform: Platform,
  private imageTools: Ng2ImgToolsService,
  private util: UtilService,
  private login: LoginProvider,
   private storage:Storage,
  ) {
    login.getUserDetails().then(val => {
      this.permissions = val.permissions;})
console.log(this.societyConfig)
    this.today = moment().format('YYYY-MM-DD');
    // ref.detach();
    setInterval(() => {
      try{
        this.ref.detectChanges();
      }catch(e){}
    }, 500);
  
    this.isAndroid = this.platform.is('android');
    complaintsProvider.getCommonAreas().then(val => {
      console.log(val)
      val.forEach(ca => {
        if(ca.type == 'commonarea'){
          this.commonAreas.push(ca);
        }
      });
      console.log(this.commonAreas);
    });

    complaintsProvider.getCustomAreas().then(val => {
      console.log(val)
      this.customAreas = val;
    })
    // complaintsProvider.getAssociatedUnits().then(val => {
    //   console.log(val)
    //   this.associatedUnits = val;
    // })
    
  var arr=this.storage.get('associatedUnits');
  if(arr){
    this.storage.get('associatedUnits').then(val=>{
       this.associatedUnits = val;
      
       })
      }
    this.data = this.navParams.data;
    console.log(this.data);
    this.initItem();

    this.events = {
       "onSubmit": function(item: any) {
          console.log("onSubmit");
       },
       "onAddVideoPhoto": function(item: any) {
          console.log("onAddVideoPhoto");
      }
    };

    this.complaintsProvider.getSocietyConfiguration().then(val => {
       this.societyConfig.complaint_lock_time =  val['complaint_lock_time'] ? val['complaint_lock_time'] : this.societyConfig.complaint_lock_time
        var from_time=val['complaint_lock_time'].from;
        var To_time=val['complaint_lock_time'].to;
        this.remark=val['add_comp_enable_remark'];
        console.log("Enable Remark",val['add_comp_enable_remark'])
        this.complaint_lock_time_from_array=from_time.split(':');
        this.complaint_lock_time_to_array=To_time.split(':');
        console.log( "test log 1",this.complaint_lock_time_from_array, this.complaint_lock_time_to_array)
        // this.societyConfig.complaint_lock_time.from=from_time;
        // this.societyConfig.complaint_lock_time.to=To_time;

    })

  }

  createItem(type: string){
    if(type == "time"){
      this.item.probable_date = this.myDate;
      this.item.probable_time = `${this.convertTime(this.vFromDate)} to ${this.convertTime(this.vToDate)}`
    }
    if(this.description)
    this.item.description = this.description;
    if(this.societyId)
    this.item.constant_society_id = this.societyId;
    this.item.severity = "normal";
  }
  // minTime(time){
   
  //   let hoursMinutes = time.split(':');
  //   var hrs =+hoursMinutes[0];
  //   let minutes = +hoursMinutes[1];
  //  let minTime= hrs>12 ?  hrs%12 : hrs;
  //  var min = minutes < 10 ? '0'+minutes : minutes;
  //   if(minTime<10){
  //  var strTime ="0"+ minTime+ ':' + min;
  //   }
  //   else{
  //     var strTime = minTime+ ':' + min;
  //   }

  //  return strTime;

    
  // }


  initItem(){
    this.item = {};
    this.item.sub_category = this.data.item.name;
    this.item.complaint_type = this.data.group.id;
    if(this.item.sub_category == "other"){
      this.disableDesc = false;
    }
  }
  displayErrorAlert(err){
    console.log(err);
    // let alert = this.alertCtrl.create({
    //     title: 'Error',
    //     subTitle: 'Error while trying to capture picture',
    //     buttons: ['OK']
    //   });
    // alert.present();
  }

  convertTime(date){
    console.log('click..',date);
    let hoursMinutes = date.split(':');
    let time = this.formatAMPM(hoursMinutes);
    return time;
  }
    
  formatAMPM(date) {
    var hours = +date[0];
    var minutes = +date[1];
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    var min = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + min + ' ' + ampm;
    return strTime;
  }

  validateTime(){
    let fromArray = this.vFromDate.toString().split(':');
    let toArray = this.vToDate.toString().split(':');
    let diff = ((+toArray[1])+(+toArray[0])*60) - ((+fromArray[1])+(+fromArray[0]*60));
    console.log("selected time array",fromArray,toArray)
    

    if(diff < 120){
      return false;
    }else{
      return true;  
    }
  }
  validateLockTime(){
    let fromArray = this.vFromDate.toString().split(':');
    let toArray = this.vToDate.toString().split(':');
    console.log(+fromArray[0],+toArray[0])
    if((+fromArray[0]< +this.complaint_lock_time_from_array[0])||(+toArray[0]>+this.complaint_lock_time_to_array[0])
    ){
      console.log("condtion true")
      return false;
    }
    else{
      return true;
    }
  }

  validateVisitTime(){
    if(this.visit == "time" && this.vToDate && this.vFromDate && this.myDate){
      if(this.vToDate && this.vFromDate && this.myDate ){
        if(!this.validateTime()){
          this.toast.presentToast("Minimum visit hours must be greater than 2");
          return 0;
        }
        if(!this.validateLockTime()){
          this.toast.presentToast(`complaint can be locked between ${this.formatAMPM(this.complaint_lock_time_from_array)} to ${this.formatAMPM(this.complaint_lock_time_to_array)}`);
          

        }
      } else{
        this.toast.presentToast("Fill out the date and time");
      }
      
    } 
  }
    
  onEvent() {
    console.log(this.visit);
    console.log(this.item);

    if(!this.disableDesc && (!this.description || this.description == "")){
      this.toast.presentToast("Provide a description");
      return 0;
    }
    
    if(this.visit == "time"){
      if(this.vToDate && this.vFromDate && this.myDate ){
        if(this.validateTime()){
          this.createItem("time");
          this.addComplaint();
        }else{
          this.toast.presentToast("Minimum visit hours must be greater than 2");
          return 0;
        }
      } else{
        this.toast.presentToast("Fill out the date and time");
      }
    } else if(this.visit == "asap"){
      this.createItem("asap");
      console.log(this.item);
      this.addComplaint();
    } else{
      let alert = this.alertCtrl.create({
        title: 'Message',
        subTitle: 'Select the visit time',
        buttons: ['Dismiss']
      });
      alert.present();
    }
  }

  addComplaint(){
    let loader = this.loadingCtrl.create({});
    if(this.data.item && this.data.item.id){
      this.item.sub_category_id = this.data.item.id;
    }
    if(this.flat_no){
      this.item.unit_no=this.flat_no;
    }
    console.log('addcomplaint---item..', this.item)
    loader.present().then(() => {
      this.complaintsProvider.addComplaint(this.item).then(val => {
        if(val.status == "success"){
          loader.dismiss();
          this.navCtrl.push(
            ComplaintTabsPage
          ).then(() =>  {
            this.util.clearNavStack(this.navCtrl);
          });
        } else{
          loader.dismiss();
          let alert = this.alertCtrl.create({
            title: 'Message',
            subTitle: val.message,
            buttons: ['Dismiss']
          });
          alert.present();
        }
      });
    });
  }
  takePicture() {
    this.extra.clickPicture().then(val=>{
      var file = 'data:image/jpeg;base64,' + val
      // console.log("resized file-----", file);
      this.item.file = file;
      this.uploaded = true;
    });
  };

  fileChoose(){
      this.extra.imgPicker().then(val => {
        var file = 'data:image/jpeg;base64,' + val[0]
        this.item.file = file;
        this.uploaded = true;
        this.ref.detectChanges();
      });
  }

  closeImg(){
    this.uploaded = false;
    this.item.file = null;
    this.ref.detectChanges();
  }

  back(){
    this.navCtrl.pop();
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad AddComplaintsFormPage');
  }

  changeListener($event) : void {
    console.log('change changeListener');
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    console.log('readThis lol');
    var file:File = inputValue.files[0];
    console.log(file);
    console.log(file.name)
    console.log(file.size)
    this.compressing = true;
    this.imageTools.resize([file], 500, 500).subscribe(val => {
      console.log('inside....');
      console.log(val);
      var reader = new FileReader();
      reader.readAsDataURL(val); 
      reader.onloadend = () => {
        this.item.file = reader.result;
        this.uploaded = true;        
      }
      this.compressing = false;
      console.log(this.item);
    }, err => {
      this.compressing = false;
      this.toast.presentToast("Unable to compress");
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/add-complaints-form/add-complaints-form.ts